import React from "react";

import Carousel from "../carousel";

import styles from "./styles.m.css";
import { checkAppSlug } from "../../utils/utils";

class ApplinkSlider extends React.Component {
  render() {
    if (checkAppSlug()) {
      return false;
    }

    return (
      <div className={styles["e-book"]}>
        <h3 className={styles["e-book-headline"]}>விகடனின் அன்புப் பரிசு! - Get your E-Book gifts on Vikatan App</h3>
        <Carousel
          className={styles["carousel"]}
          options={{
            type: "carousel",
            perView: 4,
            gap: 10,
            rewind: false,
            autoplay: 2500,
            peek: {
              before: 0,
              after: 244
            },
            breakpoints: {
              767: {
                perView: 3,
                gap: 110,
                peek: {
                  before: 0,
                  after: 104
                }
              },
              991: {
                perView: 2,
                gap: 30,
                peek: {
                  before: 30,
                  after: 244
                }
              }
            }
          }}
          renderCenterLeftControls={({ previousSlide }) => {
            return null;
          }}
          renderCenterRightControls={({ nextSlide }) => {
            return null;
          }}
          renderBottomCenterControls={({ currentSlide, goToSlide }) => {
            return null;
          }}
        >
          <div className={styles["book-item"]}>
            <img src="https://image.vikatan.com/books/medium/77.jpg" />
            <div className={styles["books-content"]}>
              <h6 className={styles["books-headline"]}>பெரியார்</h6>
              <a
                className={styles["books-a"]}
                href="https://vikatanapp.page.link/?link=https://www.vikatan.com/mobile-deeplink/eBook_preview/77&amp;apn=com.vikatanapp&amp;utm_source=web&amp;utm_medium=wfhpage&amp;ofl=https://play.google.com/store/apps/details?id=com.vikatanapp&amp;referrer=utm_source%3Dwebsite%26utm_medium%3Dwhfpage"
              >
                Read
              </a>
            </div>
          </div>
          <div className={styles["book-item"]}>
            <img src="https://image.vikatan.com/books/medium/408.jpg" />
            <div className={styles["books-content"]}>
              <h6 className={styles["books-headline"]}>டூயட் கிளினிக்</h6>
              <a
                className={styles["books-a"]}
                href="https://vikatanapp.page.link/?link=https://www.vikatan.com/mobile-deeplink/eBook_preview/77&amp;apn=com.vikatanapp&amp;utm_source=web&amp;utm_medium=wfhpage&amp;ofl=https://play.google.com/store/apps/details?id=com.vikatanapp&amp;referrer=utm_source%3Dwebsite%26utm_medium%3Dwhfpage"
              >
                Read
              </a>
            </div>
          </div>
          <div className={styles["book-item"]}>
            <img src="https://image.vikatan.com/books/medium/1087.jpg" />
            <div className={styles["books-content"]}>
              <h6 className={styles["books-headline"]}>சுஜாதாட்ஸ்</h6>
              <a
                className={styles["books-a"]}
                href="https://vikatanapp.page.link/?link=https://www.vikatan.com/mobile-deeplink/eBook_preview/77&amp;apn=com.vikatanapp&amp;utm_source=web&amp;utm_medium=wfhpage&amp;ofl=https://play.google.com/store/apps/details?id=com.vikatanapp&amp;referrer=utm_source%3Dwebsite%26utm_medium%3Dwhfpage"
              >
                Read
              </a>
            </div>
          </div>
          <div className={styles["book-item"]}>
            <img src="https://image.vikatan.com/books/medium/1761.jpg" />
            <div className={styles["books-content"]}>
              <h6 className={styles["books-headline"]}>ஷேர் மார்க்கெட் A to Z </h6>
              <a
                className={styles["books-a"]}
                href="https://vikatanapp.page.link/?link=https://www.vikatan.com/mobile-deeplink/eBook_preview/77&amp;apn=com.vikatanapp&amp;utm_source=web&amp;utm_medium=wfhpage&amp;ofl=https://play.google.com/store/apps/details?id=com.vikatanapp&amp;referrer=utm_source%3Dwebsite%26utm_medium%3Dwhfpage"
              >
                Read
              </a>
            </div>
          </div>
          <div className={styles["book-item"]}>
            <img src="https://image.vikatan.com/books/medium/2112.jpg" />
            <div className={styles["books-content"]}>
              <h6 className={styles["books-headline"]}>ஏழாம் சுவை</h6>
              <a
                className={styles["books-a"]}
                href="https://vikatanapp.page.link/?link=https://www.vikatan.com/mobile-deeplink/eBook_preview/77&amp;apn=com.vikatanapp&amp;utm_source=web&amp;utm_medium=wfhpage&amp;ofl=https://play.google.com/store/apps/details?id=com.vikatanapp&amp;referrer=utm_source%3Dwebsite%26utm_medium%3Dwhfpage"
              >
                Read
              </a>
            </div>
          </div>
          <div className={styles["book-item"]}>
            <img src="https://image.vikatan.com/books/medium/2373.jpg" />
            <div className={styles["books-content"]}>
              <h6 className={styles["books-headline"]}>தேவதைக் கதைகள்</h6>
              <a
                className={styles["books-a"]}
                href="https://vikatanapp.page.link/?link=https://www.vikatan.com/mobile-deeplink/eBook_preview/77&amp;apn=com.vikatanapp&amp;utm_source=web&amp;utm_medium=wfhpage&amp;ofl=https://play.google.com/store/apps/details?id=com.vikatanapp&amp;referrer=utm_source%3Dwebsite%26utm_medium%3Dwhfpage"
              >
                Read
              </a>
            </div>
          </div>
          <div className={styles["book-item"]}>
            <img src="https://image.vikatan.com/books/medium/2377.jpg" />
            <div className={styles["books-content"]}>
              <h6 className={styles["books-headline"]}>தமிழகத்து பிசினஸ்மேன்கள்</h6>
              <a
                className={styles["books-a"]}
                href="https://vikatanapp.page.link/?link=https://www.vikatan.com/mobile-deeplink/eBook_preview/77&amp;apn=com.vikatanapp&amp;utm_source=web&amp;utm_medium=wfhpage&amp;ofl=https://play.google.com/store/apps/details?id=com.vikatanapp&amp;referrer=utm_source%3Dwebsite%26utm_medium%3Dwhfpage"
              >
                Read
              </a>
            </div>
          </div>
          <div className={styles["book-item"]}>
            <img src="https://image.vikatan.com/books/medium/2380.jpg" />
            <div className={styles["books-content"]}>
              <h6 className={styles["books-headline"]}>நெடுஞ்சாலை வாழ்க்கை</h6>
              <a
                className={styles["books-a"]}
                href="https://vikatanapp.page.link/?link=https://www.vikatan.com/mobile-deeplink/eBook_preview/77&amp;apn=com.vikatanapp&amp;utm_source=web&amp;utm_medium=wfhpage&amp;ofl=https://play.google.com/store/apps/details?id=com.vikatanapp&amp;referrer=utm_source%3Dwebsite%26utm_medium%3Dwhfpage"
              >
                Read
              </a>
            </div>
          </div>
        </Carousel>
        <p className={styles["bottom-para"]}>*மே 31 வரை...Vikatan App-ல் இலவசமாக படிக்கலாம்!</p>
      </div>
    );
  }
}

export default ApplinkSlider;
